import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useState } from 'react';

type DivorceDateInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  label: string;
  required?: boolean;
};

export function DivorceDateInput({
  value,
  onChange,
  label,
  required,
}: DivorceDateInputProps) {
  const [divorceDate, setDivorceDate] = useState(value ? dayjs(value) : null);

  const updateFormDivorceDate = (newValue: dayjs.Dayjs | null) => {
    const newDivorceDate = newValue?.isValid()
      ? newValue?.format('YYYY-MM-DD').split('T')[0]
      : null;

    if (newDivorceDate === value) {
      return;
    }

    onChange(newDivorceDate);
  };

  return (
    <DatePicker
      label={label}
      disableFuture
      openTo='year'
      views={['year', 'month', 'day']}
      value={divorceDate}
      onChange={newValue => {
        setDivorceDate(newValue);
        updateFormDivorceDate(newValue);
      }}
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          required,
        },
      }}
    />
  );
}
